<template>
  <!-- 综合查询 -->
  <div class="container">
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems glo_bgcMainColor"
          @click="addOne()"
          >移入库存</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems glo_bgcMainColor"
          @click="delOne()"
          >移出库存</el-button
        >
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="addStockCargoarea()"
          >放入收货仓号</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="printBtns">打印</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isselection="true"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
      @fildsClick="fildsClick"
      ref="mytable"
    ></mytable>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageStart"
      :page-size="pageTotal"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageCount"
    >
    </el-pagination>
    <!-- 导出 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>
    <myDialog
      diaWidth="900px"
      dialogTitle="加入库存"
      :isShowDialog="isShowDialog"
      :showConfirm="true"
      @handleCloseDia="closeDialog"
      @diaCancelBtn="closeDialog"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <edit ref="editForm"></edit>
    </myDialog>
    <myDialog
      diaWidth="300px"
      dialogTitle="放入收货仓号"
      :isShowDialog="isShowDialog2"
      :showConfirm="true"
      @handleCloseDia="closeDialog2"
      @diaCancelBtn="closeDialog2"
      @diaConfirmBtn="diaConfirmBtn2"
    >
      <el-form :model="cargoareaForm" label-position="left" label-width="80px">
        <el-form-item prop="areaIId" label="收货仓号">
            <el-select v-model="cargoareaForm.areaId" filterable>
                <el-option v-for="area in areas" :label="area.cargoareaName" :value="area.id" :key="area.id"></el-option>
            </el-select>
        </el-form-item>
      </el-form>
    </myDialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import edit from "./Edit.vue";
export default {
  mixins: [tableListNew, exportjs, mixin_print],
  components: {
    queryCondition,
    sorttable,
    paging,
    queryBtns,
    mytable,
    myDialog,
    edit,
  },
  data() {
    return {
      isShowOperate: false, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      //需要单独点击的列字段名数组
      fieldList: ["waybillNumber"],
      Operatewidth: "220px", //操作列的列宽
      //=======================导出相关 结束 =======================

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据

      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "库区管理", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "admin_stock_list_v5", //  页面标识
      reportFiledsNumber: "admin_stock_list_v5", // 动态 条件、表头
      activeName: "first",
      selectedId: "",
      selectedNumber: "",
      isShowDialog: false,
      isShowDialog2:false,
      editCargoareaId: "",
      cargoareaForm:{
        areaId:''
      },
      areas:[],
      stockId:''
    };
  },
  updated() {},
  created() {
    
  },
  mounted() {},
  activated() {},

  watch: {},
  methods: {
    async getAreas(storageId){
        const res = await this.$API.runList({
            number:'admin_storage_cargo_area_list_v5',
            storageId
        })
        this.areas = res
    },
    fildsClick(row) {
      this.selectedId = row.waybillSplitId;
      this.selectedNumber = row.number;
    },
    addOne() {
      this.isShowDialog = true;
    },
    addStockCargoarea(row) {
      if (!row && this.selectTableData.length == 0) {
        this.$message.error("请选择货物记录");
        return;
      }
      if (!row) {
        row = this.selectTableData[0];
      }
      this.cargoareaForm.stockId = row.stockId;
      this.getAreas(row.stockDeptId)
      this.isShowDialog2 = true;
    },
    delOne(row) {
      if (!row && this.selectTableData.length == 0) {
        this.$message.error("请选择货物记录");
        return;
      }
      let rows = []
      if (row) {
        rows = [row]
      }else{
        rows = this.selectTableData
      }
      this.$confirm("确认把【" + rows.length +" 】条货物记录移出库存？")
      .then(res=>{
        this.$API.outStock({
            stockIds:rows.map(item=>item.stockId)
        }).then(rr=>{
            this.getData()
            this.clearSelection()
        }).catch(ee=>{

        })
      })
    },
    diaConfirmBtn() {
      this.$refs.editForm
        .save()
        .then((res) => {
          this.isShowDialog = false;
          this.getData()
        })
        .catch((err) => {});
    },
    closeDialog() {
      this.$refs.editForm.reset();
      this.isShowDialog = false
    },
    diaConfirmBtn2() {
      this.$API.addStockCargoarea({
        cargoareaId:this.cargoareaForm.areaId,
        stockIds:[this.cargoareaForm.stockId]
      }).then(res=>{
        this.isShowDialog2 = false
        this.getData()
      }).catch(err=>{

      })
    },
    closeDialog2() {
      this.cargoareaForm = {}
      this.isShowDialog2 = false
    },
    clearSelection(){
        this.$refs.mytabl.clearSelection()
    }
  },
};
</script>


<style scoped lang="less">
.container {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
</style>
